import { render, staticRenderFns } from "./tag_summary_detail.vue?vue&type=template&id=a130fcc0&scoped=true"
import script from "./tag_summary_detail.vue?vue&type=script&lang=js"
export * from "./tag_summary_detail.vue?vue&type=script&lang=js"
import style0 from "./tag_summary_detail.vue?vue&type=style&index=0&id=a130fcc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a130fcc0",
  null
  
)

export default component.exports